var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item",on:{"click":function($event){return _vm.toggleNavMenu()}}},[_vm._v(" ."+_vm._s(_vm.scope)+" ")]),_c('li',{staticClass:"breadcrumb-item"},[_vm._v(" ."+_vm._s(_vm.section)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }